/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Box, Card, useTheme } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import InsightDebtorsTable from '@/components/tables/InsightDebtorsTable';

export const InsightPolicyTransactionTab = () => {
	const theme = useTheme();

	const { clientRow } = useObjectContext();

	return (
		<Box
			sx={{
				'& .MuiDataGrid-parentDiv': {
					border: `1px solid ${theme.palette.divider}`,
					borderRadius: '8px',
					backgroundColor: theme.palette.background.paper,
				},
				'& .MuiDataGrid-root': {
					borderRadius: '8px',
				},
			}}
		>
			<InsightDebtorsTable
				clientId={clientRow?.insightId}
				sortByEffectiveDate={true}
				displayCheckBoxes={false}
				columnType='client'
				displayTransactionFilter={true}
			/>
		</Box>
	);
};
InsightPolicyTransactionTab.displayName = 'InsightPolicyTransactionTab';
